import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { bootstrapTelegramUI } from '../../shared/telegram.ts'
import './i18n'
import '../../shared/tokens.css'
import '../../shared/shell.css'
import '../../shared/game-polish.css'
import './index.css'
import '@shared/folded-veil.css'
import '../../shared/round2-game-polish.css'
import '../../shared/round3-brand.css'
import '../../shared/snowfold-village.css'
import '@shared/round10-reference-layout.css'
import './round18-mines-art.css'
import './round20-mines-idle-grid.css'
import '../../shared/game-header.css'
import '../../shared/bottom-sheet.css'
import '../../shared/bet-dock.css'
import '../../shared/single-viewport.css'
import App from './App'

bootstrapTelegramUI()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
